import * as React from "react";
const SvgFiRrFaceCowboyHat = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-face-cowboy-hat_svg__a)">
      <path
        fill="#062147"
        d="M7 12.5a1.5 1.5 0 1 1 3.001.001 1.5 1.5 0 0 1-3-.001m10 0a1.5 1.5 0 1 0-3 .001 1.5 1.5 0 0 0 3-.001m6.707-6.793C23.532 5.883 19.33 10 12 10S.468 5.883.293 5.707a.999.999 0 0 1 1.412-1.416c.026.026.934.895 2.588 1.786a177 177 0 0 1 1.43-3.478C6.665.451 8.24 0 9.395 0c.87 0 1.853.376 2.566.98.76-.607 1.727-.98 2.587-.98 1.621 0 3.016.972 3.73 2.598.331.758 1.06 2.563 1.43 3.48 1.66-.895 2.568-1.768 2.586-1.786a1 1 0 0 1 1.413 1.416zM12 8c2.328 0 4.303-.478 5.887-1.089-.352-.874-1.113-2.76-1.44-3.51C16.26 2.98 15.706 2 14.548 2c-.384 0-.887.201-1.222.49a2.065 2.065 0 0 1-2.657.017C10.317 2.208 9.793 2 9.396 2c-.605 0-1.298.167-1.84 1.402-.328.749-1.09 2.635-1.44 3.509A16.3 16.3 0 0 0 12.001 8zm8.155 2.057a1 1 0 0 0-.61 1.276A8 8 0 0 1 20 14c0 4.411-3.589 8-8 8s-8-3.589-8-8c0-.914.153-1.812.455-2.667a1 1 0 0 0-1.886-.666A10 10 0 0 0 2.001 14c0 5.514 4.486 10 10 10s10-4.486 10-10c0-1.142-.19-2.263-.568-3.333a1.004 1.004 0 0 0-1.276-.61zM7.128 17.234c.85 1.282 2.372 2.767 4.871 2.767s4.016-1.484 4.865-2.767c.395-.597-.157-1.365-.877-1.214-.93.195-1.956.98-3.988.981-2.032 0-3.065-.785-3.995-.981-.72-.151-1.27.617-.876 1.214"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-face-cowboy-hat_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrFaceCowboyHat;
